export default "__VITE_ASSET__BK0PblBl__"